import type { TemplateRenderer } from '../../types';
import type { PageData } from './types';

// findIndex lands on the first overflow page of a month that spans multiple
// pages; numeric month/year comparison is timezone-proof.
export const getPageIndexForDate: NonNullable<
  TemplateRenderer<PageData>['getPageIndexForDate']
> = (pages, date) =>
  pages.findIndex((page) =>
    page.months.some(
      ({ month }) => month.month === date.month && month.year === date.year
    )
  );
